import { env } from '@hb/hbridge';
import { getLotteryActivity } from '@/api/vip';
import { getTokenAndLocation } from '@/utils';
import { safeJsonStringify } from '@/utils/tools';
import {
  RATIO_ICON_MAP,
  LOTTERY_PRIZE_STATUS,
  LOTTERY_PRIZE_TAG_MAP,
} from '../consts';

/**
 * @description 获取抽奖按钮名称
 * @function getPrizeBtnName
 * @param {*} prize 奖品信息
 * @param {*} options 选项
 * @returns
 */
export function getPrizeBtnName(prize, options) {
  const { status, statusDesc } = prize || {};
  const { lotteryTime } = options || {};

  // 参与抽奖且已设置提醒且app环境
  if (status === LOTTERY_PRIZE_STATUS.signed && env.isEasyBikeApp) {
    const time = lotteryTime ? lotteryTime.split(':')[0] : '';
    return `${time}点开奖`;
  }

  // 参与抽奖且非APP环境，不展示提醒，直接设置同开奖状态
  if (status === LOTTERY_PRIZE_STATUS.signed && !env.isEasyBikeApp) {
    const time = lotteryTime ? lotteryTime.split(':')[0] : '';
    return `${time}点开奖`;
  }

  if (statusDesc === '开奖提醒我') {
    return '开奖提醒';
  }

  return statusDesc;
}

/**
 * @description 获取抽奖按钮样式
 * @function getPrizeBtnStyle
 * @param {*} status 奖品状态
 * @param {*} options 选项
 * @returns
 */
export function getPrizeBtnStyle(status) {
  if (status === LOTTERY_PRIZE_STATUS.signed && !env.isEasyBikeApp) {
    return 'grey';
  }

  if (status === LOTTERY_PRIZE_STATUS.draw_limited) {
    return '';
  }

  switch (status) {
    case LOTTERY_PRIZE_STATUS.drawing:
      return 'disabled';
    case LOTTERY_PRIZE_STATUS.signed:
      return 'grey';
    case LOTTERY_PRIZE_STATUS.draw_limited:
      return 'disabled';
    default:
      return '';
  }
}

/**
 * @description 抽奖活动数据适配
 * @function lotteryActivityAdapter
 * @param {*} data 抽奖活动数据
 * @param {*} options 选项
 * @returns
 */
export function lotteryActivityAdapter(data) {
  const {
    prizeInfoGroup = [],
    ratio,
    lotteryTime,
    campaignCode,
    batchNo,
  } = data || {};
  const lotteryGroupList = [];

  // 抽奖活动列表
  prizeInfoGroup.forEach((item, index) => {
    const { groupName, prizeInfos = [] } = item || {};
    if (prizeInfos.length === 0) return;

    // 抽奖奖品列表
    const newPrizeList = prizeInfos.map((prize) => {
      const { status } = prize || {};
      return {
        ...prize,
        isLocked: status === LOTTERY_PRIZE_STATUS.draw_limited,
        btnName: getPrizeBtnName(prize, {
          lotteryTime,
        }),
        btnStyle: getPrizeBtnStyle(status),
      };
    });

    lotteryGroupList.push({
      groupName,
      groupTag: LOTTERY_PRIZE_TAG_MAP[index + 1] || '',
      prizeList: newPrizeList.slice(0, 2),
    });
  });

  return {
    lotteryData: {
      ratioIcon: RATIO_ICON_MAP[ratio] || '',
      lotteryTime,
      campaignCode,
      batchNo,
    },
    lotteryGroupList,
  };
}

/**
 * @description 获取抽奖活动数据
 * @function getLotteryActivityData
 * @param {*} options 选项
 * @returns
 */
export async function getLotteryActivityData(options) {
  const { isOutOrder = false } = options || {};

  try {
    const { token, adCode, cityCode } = await getTokenAndLocation();
    const result = await getLotteryActivity({
      adCode,
      cityCode,
      token,
      isOutOrder,
    });
    const { code, data } = result || {};

    if (code === 0 && data) {
      return { success: true, data };
    }
    return { success: false, data: null };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('getLotteryActivityData => error', safeJsonStringify(error));
    return { success: false, data: null };
  }
}
